import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface ContentCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: boolean;
}

/**
 * Single Responsibility: Consistent content card styling
 * Open/Closed: Configurable padding and shadow through props
 */
export const ContentCard: React.FC<ContentCardProps> = ({
  children,
  className,
  padding = 'md',
  shadow = true,
}) => {
  const { theme } = useTheme();

  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={cn(
        'rounded-lg border transition-colors',
        shadow && 'shadow-sm',
        theme === 'dark' ? 'bg-slate-800/50 border-slate-700' : 'bg-white/95 border-slate-300/80',
        paddingClasses[padding],
        className
      )}
    >
      {children}
    </div>
  );
};
